<template>
  <v-container class="p-product-detail pa-0">
    <v-layout class="pd-top block" wrap>
      <v-flex shrink class="mr-4">
        <img class="pd-top-img" :src="productDetail.productImage"  alt=""/>
      </v-flex>
      <v-flex class="pd-top-content">
        <v-layout justify-space-between column fill-height>
          <v-flex>
            <h1>{{ product.name }}</h1>
            <p class="subheading"
               v-if="productDetail.hasOwnProperty('features') && productDetail.features.length > 0">{{
              productDetail.features[0] }}</p>
          </v-flex>
          <v-flex shrink>
            <v-layout align-end justify-space-between wrap>
              <v-flex xs12 md6>
                <ul class="pl-0" v-if="productDetail.hasOwnProperty('conditions') && productDetail.conditions.length >
                 0">
                  <li v-for="item in productDetail.conditions" :key="item.title" class="mt-1">
                    <c-icon :name="item.icon"></c-icon>
                    <span>{{ item.title ? item.title + '：' : '' }}{{item.content}}</span>
                  </li>
                </ul>
              </v-flex>

              <v-flex xs12 md6>
                <div class="mt-2 text-md-right">
                  <div class='btn' v-if='productDetail.link'><a :href="productDetail.link">立即投保</a></div>
                  <span
                    class="pd-top-company"
                  >由{{ insurer.fullName }}承保并提供理赔服务</span>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout class="mt-3 mb-5">
      <v-flex>
        <!-- tabs -->
        <v-tabs
          v-model="tabActive"
          v-if="productModule"
          grow
          slider-color="primary"
          :class="[productModule.length > 1 ? 'card-tabs' : 'card-tabs-only', 'sticky-tabs']"
        >
          <v-tab v-for="module in productModule" :key="module.title" ripple>{{ module.title }}</v-tab>

          <v-tab-item v-for="module in productModule" :key="module.title">
            <Claims :value = "module.content" />
            <!-- <div class='btn' v-if='module.link'><a :href="module.link">立即投保</a></div> -->
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-flex class="operation-wrap" v-if="breakpoint.lgAndUp">
        <Operation :code="code" :productDetail="productDetail" :product="product"></Operation>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Operation from "./components/Operation";
import Claims from "./components/Claims";

export default {
  components: {
    Operation,
    Claims,
  },
  props: {
    code: String
  },
  data() {
    return {
      tabActive: 0,
      product: {},
      productDetail: {},
      productModule: {},
      insurer: {},
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail(){
      // 动态加载与产品 code 对应的详情 json，新增产品只需放置 productdetail_<code>.json 即可兼容
      this.$axios.get(`/json/productdetail_${this.code}.json`, {productId: this.code}).then(response => {
        console.log(response)
        this.product = response.product;
        this.productDetail = response.productDetailBo;
        this.productModule = response.productModule;
        this.insurer = response.insurerBO;
        if (this.productDetail.hasOwnProperty("features") && this.productDetail.features !== ""){
          this.productDetail.features = JSON.parse(this.productDetail.features);
        }else{
          this.productDetail.features = [];
        }
        if (this.productDetail.hasOwnProperty("conditions") && this.productDetail.conditions !== ""){
          this.productDetail.conditions = JSON.parse(this.productDetail.conditions);
        }else{
          this.productDetail.conditions = [];
        }
      });
    }
  }
};
</script>

<style lang="scss">
.p-product-detail {
  h1 {
    font-size: 1.75em;
    font-weight: 500;
  }
  h2 {
    font-size: 1.6em;
    font-weight: 500;
  }
  .subheading {
    font-size: 1.125em;
    color: #666666;
    margin-top: 0.9em;
  }
  .card-tabs-only {
    // 重写 light 为 UI设计稿
    .v-tabs__container {
      background-color: #efefef;
      .v-tabs__slider-wrapper {
        display: none;
      }
      .v-tabs__item--active {
        background-color: #efefef !important;
        color: #000 !important;
      }
    }
  }
  // tabs 标题栏吸顶：只固定 tab 按钮，内容继续滚动
  .sticky-tabs .v-tabs__bar {
    position: sticky;
    top: 120px;
    z-index: 100;
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
.p-product-detail {
  h1 {
    font-size: 1.75em;
    font-weight: 500;
  }
  .subheading {
    font-size: 1.125em;
    color: #666666;
    margin-top: 0.9em;
    max-width: 70%;
  }
  .pd-top {
    padding-right: 1.5em;
    &-img {
      width: 300px;
      height: 220px;
    }
    &-company {
      font-size: 14px;
      color: #cccccc;
    }
  }
  .pd-top-content{
    max-width: 70%;
  }
  .operation-wrap {
    width: 330px;
    flex: none;
    margin-left: 20px;
  }
  .btn {
    text-align: right;
    margin-bottom: 20px;
    a {
      padding: 10px 80px;
      color: #fff;
      background: #dd122a;
    }
  }
}
</style>
